import { NgModule } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule, SharedModule } from '../../shared';
import { CoreModule } from '../../core/core.module';
import { CommonModule } from '@angular/common';
import { FlorderModule } from 'app/modules/florder/florder.module';
import { RelocationsRoutingModule } from 'app/modules/relocations/relocations-routing.module';
import { RelocationPageContainer } from '../relocations/relocation-page-container/relocation-page.container';
import { RelocationFilterComponent } from '../relocations/relocation-filter/relocation-filter.component';
import { RelocationListComponent } from '../relocations/relocation-list/relocation-list.component';

@NgModule({
  imports: [CommonModule, FlorderModule, RelocationsRoutingModule, AngularMaterialModule, SharedModule, CoreModule, ReactiveFormsModule],
  exports: [],
  declarations: [
    RelocationPageContainer,
    RelocationFilterComponent,
    RelocationListComponent,
  ],
  providers: [],
})
export class RelocationsModule {}
